import { FieldMultiSelect } from "./FieldMultiSelect";

type Props = {
  id: string;
  label: string;
  options: string[];
  value: unknown;
  onChange: (v: string[]) => void;
  error?: string;
};

/** Symptom checklist — same behavior as multi_select with responsive grid styling. */
export function FieldSymptomGrid(props: Props) {
  return <FieldMultiSelect {...props} />;
}
